<svelte:options />

<script>
    import { preventDefault } from 'svelte/legacy';

    export const submit = formSubmit;
    export const reset = resetForm;

    import { createEventDispatcher } from 'svelte';
    import * as Sentry from '@sentry/sveltekit';
    /**
     * @typedef {Object} Props
     * @property {any} [data]
     * @property {string} [direction]
     * @property {any} [associatedID]
     * @property {boolean} [valid]
     * @property {import('svelte').Snippet} [children]
     * @property {string} [class]
     * @property {boolean} [submitOnEnter] - when false, pressing Enter in an input doesn't submit the form
     */
    let {
        data = $bindable({}),
        direction = 'column',
        associatedID = null,
        valid = $bindable(false),
        children,
        onsubmit = () => {},
        submitOnEnter = true,
        class: className = '',
    } = $props();

    let form = $state(null);
    let submitButton = $state(null);

    const dispatch = createEventDispatcher();

    function formSubmit() {
        // form.submit()
        submitButton.click(); // to get around sveltekit form actions submit from button, not directly
    }

    function resetForm() {
        form.reset();
    }

    function handleKeydown(e) {
        // eslint-disable-next-line no-undef
        if (!submitOnEnter && e.key === 'Enter' && e.target instanceof HTMLInputElement) {
            e.preventDefault();
        }
    }

    function handleFormSubmit(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        data._associatedID = associatedID;

        const invalidElements = form.querySelectorAll(
            '.input:invalid, .textarea:invalid, select:invalid'
        );

        if (invalidElements.length === 0) {
            form.querySelectorAll('.input, .textarea, select, input[type="radio"]').forEach((n) => {
                try {
                    const name = n.attributes.getNamedItem('name')?.value;
                    const fieldType = n.attributes.getNamedItem('type')
                        ? n.attributes.getNamedItem('type').value
                        : null;

                    if (fieldType === 'checkbox' && name.endsWith('[]')) {
                        const _name = name.replace('[]', '');
                        if (!data[_name]) {
                            data[_name] = [];
                        }
                        if (n.checked) {
                            data[_name].push(
                                n.value ||
                                    n.attributes.getNamedItem('value').value
                            );
                        }
                    } else if (fieldType === 'checkbox') {
                        // Use checked for the value since value doesn't change
                        data[name] = n.checked;
                    } else if (name) {
                        data[name] =
                            n?.value ||
                            n?.attributes?.getNamedItem('value')?.value ||
                            null;
                    }
                } catch (err) {
                    console.error(err);
                    Sentry.captureException(err);
                }
            });

            data._valid = valid = true;
            onsubmit({
                detail: $state.snapshot(data),
                preventDefault: () => {},
                stopPropagation: () => {},
                stopImmediatePropagation: () => {},
            });
        } else {
            data._valid = valid = false;
            form.submit();
            dispatch('invalid', invalidElements);
        }
    }

    export {
        data,
        direction,
        associatedID,
        valid,
    };
</script>

<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<form
    bind:this={form}
    onsubmit={preventDefault(handleFormSubmit)}
    onkeydown={handleKeydown}
    class="form {direction} {className}"
    style="flex-direction:{direction || 'column'};"
>
    {@render children?.()}
    <button
        bind:this={submitButton}
        type="submit"
        style="position:fixed;left:-1000px;opacity:0;"
        aria-hidden="true"
        tabindex="-1"
></button>
</form>

<style>
    .form {
        display: flex;
        flex-grow: 10;
        width: 100%;
        gap: 2rem;
    }

    .row * {
        margin-right: 0.5rem;
    }
</style>
